// extracted by mini-css-extract-plugin
export default {"card":"code_card__zV7q-","header":"code_header__bsaYH","title":"code_title__JPypg"};